module.exports = __webpack_public_path__ + "img/omil.ca9d67e4.png";